import axios, { AxiosRequestConfig } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

import loader from '@/services/loader';
import storage from '@/services/storage';
import apiUrls from '@/shared/api-urls';
import { constants } from '@/shared/constants';
import { handleError } from '@/shared/helpers';
import routes from '@/shared/routes';
import { urls } from '@/shared/urls';

import user from './user';

const axiosInstance = axios.create({
	baseURL: '/',
	withCredentials: false,
	headers: {
		'Accept': 'application/json, text/javascript, */*; q=0.01',
		'Content-Type': 'application/json',
		'language': (<HTMLInputElement>document.getElementsByName('languageId')[0]).value
	},
});

axiosInstance.interceptors.request.use(config => {
	const url = config.url as string;

	if (!config.params?.skipLoader)
		loader.startRequest(url);

	// don't pass it to BE
	delete config.params?.skipLoader;

	if (Object.values(apiUrls).find(urlConfig => config.url?.includes(urlConfig.url.slice(0, urlConfig.url.indexOf('?'))))?.open)
		return config;

	const userId = storage.getItem(constants.storage.userId);
	if (url && userId) {
		const sign = url.indexOf('?') === -1 ? '?' : '&';
		config.url = `${ url }${ sign }userId=${ userId }`;
	}

	return user.userTokenPromise?.then(token => {
		config.headers.authorization = token;
		return config;
	}) as Promise<AxiosRequestConfig>;
});

axiosInstance.interceptors.response.use(
	res => {
		loader.finishRequest(res.config.url);
		return res;
	},
	err => {
		loader.finishRequest(err.config.url);
		throw err;
	}
);

window.addEventListener('unhandledrejection', e => {
	if (e.reason.isAxiosError)
		handleError()(e.reason);
});

// refresh token on 401 status
const refreshAuthLogic = (failedRequest: XMLHttpRequest) => axiosInstance.post('/selfcare/b2c/auth/refreshToken')
	.then(tokenRefreshResponse => {
		const token = tokenRefreshResponse.data.response;
		failedRequest.response.config.headers.authorization = token;
		user.refreshToken(token);
	})
	.catch(response => {
		user.clearUserData();
		if (!routes.isLoginPage())
			location.href = urls.login;

		throw { response, handled: true };
	});

createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic);
export default axiosInstance;
